<template>
  <loading v-if="loading" message="Получаем информацию по свободным местам..."></loading>
  <div v-else>
    <h3>Список заказов на ближайшие две недели</h3>
    <div class="row">
      <div class="col" v-for="chunk in chunk(days, 14)">
        <div class="card" v-for="date in chunk">
          <template v-if="isClosed(date)">
            <div class="card-header text-danger">
              {{convertDataToString(date)}}
            </div>
            <div  class="card-block bg-danger">
              Закрыто
            </div>
          </template>
          <template v-else-if="getOrdersByDate(date) && getOrdersByDate(date).length === 0">
            <div class="card-header text-success">
              {{convertDataToString(date)}} - все свободно
            </div>
            <div class="card-block bg-success">
              <button v-for="dateTime in getFreeTimesAll(date)" class="btn btn-primary btn-sm" @click="selectDate(dateTime.format('DD.MM.YYYY'), dateTime.format('HH:mm'))">{{dateTime.format('HH:mm')}}</button>
            </div>
          </template>
          <template v-else>
            <div class="card-block">
              <div class="card-header text-warning">
                {{convertDataToString(date)}} - местами занято
              </div>
              <template v-for="(obj, index) in getOrdersByDate(date)">
                <div class="row" v-if="obj.orders.length === 0">
                  <div class="col-1">
                    <button class="btn btn-primary btn-sm"
                            @click="selectDate(obj.dateTime.format('DD.MM.YYYY'), obj.dateTime.format('HH:mm'))">
                      {{obj.dateTime.format('HH:mm')}}</button>
                  </div>
                  <div class="col">Свободно</div>
                </div>
                <div v-else class="row" v-for="order in obj.orders">
                  <div class="col-1">
                    <button class="btn btn-danger btn-sm"
                            @click="selectDate(obj.dateTime.format('DD.MM.YYYY'), order.time)">{{order.time}}</button>
                  </div>
                  <div class="col-7">
                    {{order.description}}
                  </div>
                  <div class="col">
                    +7{{order.clientPhone}} {{order.clientName}}
                  </div>
                  <div class="col">
                   {{order.sum}} руб.
                  </div>
                </div>
              </template>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  import { mapState } from 'vuex'
  export default {
    params: {
      techcenterId: {
        type: Number,
        required: true
      }
    },
    name: 'TcOrdersList',
    data () {
      return {
        params: {
          dateFrom: null,
          dateTo: null
        },
        format: 'DD.MM.YYYY',
        days: []
      }
    },
    created () {
      let day = moment().startOf('day')
      this.params.dateFrom = day
        .format(this.format)
        .toString()
      let endDay = moment()
        .endOf('day')
        .add(13, 'days')
      this.params.dateTo = endDay
        .format(this.format)
        .toString()
      while (day <= endDay) {
        this.days.push(day.format('DD.MM.YYYY'))
        day = day.clone().add(1, 'd')
      }
      this.params.techcenterId = [this.techcenter.id]
      this.$store.dispatch('getOrders', this.params)
    },
    methods: {
      chunk (arr, len) {
        const chunks = []
        let i = 0
        const n = arr.length

        while (i < n) {
          chunks.push(arr.slice(i, i += len))
        }

        return chunks
      },
      convertDataToString (date) {
        moment.locale('ru')
        let dateString = moment(date, 'DD.MM.YYYY').format('dddd D MMMM Y').toString()
        dateString = dateString.charAt(0).toUpperCase() + dateString.substr(1)
        return dateString
      },
      getOrdersByDate (date) {
        let orders = this.orders.filter((order) => {
          return order.date === date && !order.canceled
        })
        if (orders.length === 0) {
          return []
        }

        let times = this.getFreeTimesAll(date)
        let newTimes = times.map((dateTime, index, arr) => {
          let timeOrders = []
          if (index === 0) {
            timeOrders = orders.filter((order) => {
              let orderDateTime = moment(order.date + '_' + order.time,
                'DD.MM.YYYY_HH:mm')
              if (orderDateTime <= dateTime) {
                return true
              }
            })
          } else if (index + 1 === arr.length) {
            timeOrders = orders.filter((order) => {
              let orderDateTime = moment(order.date + '_' + order.time,
                'DD.MM.YYYY_HH:mm')
              if (orderDateTime >= dateTime) {
                return true
              }
            })
          } else {
            timeOrders = orders.filter((order) => {
              let orderDateTime = moment(order.date + '_' + order.time,
                'DD.MM.YYYY_HH:mm')
              if (orderDateTime >= dateTime && orderDateTime < arr[index + 1]) {
                return true
              }
              return false
            })
          }

          return {
            dateTime: dateTime,
            orders: timeOrders.sort(function (a, b) {
              if (a.time > b.time) {
                return 1
              } else if (a.time < b.time) {
                return -1
              } else if (a.id > b.id) {
                return 1
              } else if (a.id < b.id) {
                return -1
              } else {
                console.error('error')
                return 0
              }
            })
          }
        })
        return newTimes
      },
      getFreeTimesAll (date) {
        let times = []
        let startHour = this.techcenter.workTimeStart.split(':')
        let endHour = this.techcenter.workTimeEnd.split(':')
        let startTime = moment(date, 'DD.MM.YYYY')
          .set('hour', startHour[0])
          .startOf('hour')
        let endTime = moment(date, 'DD.MM.YYYY')
          .set('hour', endHour[0])
          .endOf('hour')
        while (startTime <= endTime) {
          times.push(startTime)
          startTime = startTime.clone().add(30, 'm')
        }
        return times
      },
      selectDate (date, time) {
        console.log('selectDate ' + date)
        let win = window.parent
        win.postMessage({date, time}, 'https://alarmru.amocrm.ru')
      },
      isClosed (date) {
        let weekday = moment(date, 'DD.MM.YYYY').weekday() + 1
        if (weekday >= this.techcenter.workDateStart && weekday <= this.techcenter.workDateEnd) {
          return false
        }

        return true
      }
    },
    computed: {
      ...mapState({
        orders: state => state.orderStore.orders,
        loading: state => state.orderStore.loading,
        techcenter: state => state.techcenterStore.techcenter
      }),
      ordersDays () {
        return this.orders.map(function (item) {
          return item.date
        }).filter(function (value, index, self) {
          return self.indexOf(value) === index
        }).sort(function (a, b) {
          let dateA = moment(a, 'DD.MM.YYYY')
          let dateB = moment(b, 'DD.MM.YYYY')
          return dateB.isBefore(dateA) ? 1 : -1
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// TcOrdersList.vue?68c3e34c